import ExportButton from '@/features/charts/ExportButton';
import type { ChartType } from '@/features/charts/types/highcharts';
import type { Sx } from '@/shared/types/uiTypes';
import { useExportChartAction } from './useExportChartAction';

const ExportChartButton = ({
  disabled = false,
  graphType,
  isFullScreen = false,
  metadata,
  tabName,
  sx,
  iconSize
}: {
  graphType: ChartType | 'fullscreen';
  disabled?: boolean;
  isFullScreen?: boolean;
  metadata?: Record<string, string>;
  tabName?: string;
  sx?: Sx;
  iconSize?: number;
}) => {
  const { disabled: isDisabled, exportChart } = useExportChartAction({
    disabled,
    graphType,
    isFullScreen,
    metadata,
    tabName
  });

  return (
    <ExportButton
      disabled={isDisabled}
      handleClick={exportChart}
      iconSize={iconSize}
      sx={sx}
      title='Export chart'
    />
  );
};

export default ExportChartButton;
